(function () {
  'use strict';

  var RECENT_KEY = 'lyy_recent_searches';
  var MAX_RECENT = 5;

  function getRecent() {
    try {
      return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveRecent(query) {
    var q = query.trim();
    if (!q) return;
    var list = getRecent().filter(function (item) { return item.toLowerCase() !== q.toLowerCase(); });
    list.unshift(q);
    localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, MAX_RECENT)));
  }

  function clearRecent() {
    localStorage.removeItem(RECENT_KEY);
  }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(0);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var searchInput = document.getElementById('ch-search-input');
    var suggestPanel = document.getElementById('ch-search-suggest');
    var searchWrap = document.querySelector('.custom-header__search-wrap');
    var backdrop = document.getElementById('lyy-search-backdrop');
    var trendingDataEl = document.getElementById('lyy-trending-data');
    var suggestTimer = null;

    if (!searchInput || !suggestPanel) return;

    var trending = [];
    if (trendingDataEl) {
      try {
        trending = JSON.parse(trendingDataEl.textContent);
      } catch (e) {
        trending = [];
      }
    }

    function setOpen(open) {
      if (searchWrap) searchWrap.classList.toggle('is-search-open', open);
      if (backdrop) backdrop.classList.toggle('is-visible', open);
    }

    function hideSuggest() {
      suggestPanel.hidden = true;
      suggestPanel.innerHTML = '';
      setOpen(false);
    }

    function renderRecentHTML() {
      var recent = getRecent();
      if (!recent.length) return '';
      var chips = recent.map(function (q) {
        return '<button type="button" class="lyy-search-recent-chip" data-query="' + q.replace(/"/g, '&quot;') + '">' +
          '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#9aa1ac" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15.5 14"/></svg>' +
          q + '</button>';
      }).join('');
      return '<div class="lyy-search-recent-header"><span class="lyy-search-label">Recent</span>' +
        '<button type="button" class="lyy-search-recent-clear">Clear</button></div>' +
        '<div class="lyy-search-recent-chips">' + chips + '</div>';
    }

    function renderTrendingHTML() {
      if (!trending.length) {
        return '<div class="lyy-search-pane-right"><div class="lyy-search-label">Trending now</div><p style="font-size:12px;color:#8b93a0;">No trending products configured.</p></div>';
      }
      var items = trending.map(function (p) {
        var img = p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '';
        return '<a href="' + p.url + '" class="lyy-search-trend-item">' +
          '<div class="lyy-search-trend-thumb">' + img + '</div>' +
          '<div><div class="lyy-search-trend-title">' + p.title + '</div>' +
          '<div class="lyy-search-trend-price">' + p.price + '</div></div>' +
          '<span class="lyy-search-hot">HOT</span></a>';
      }).join('');
      return '<div class="lyy-search-pane-right"><div class="lyy-search-label">Trending now</div>' + items + '</div>';
    }

    function bindPanelEvents() {
      suggestPanel.querySelectorAll('[data-query]').forEach(function (el) {
        el.addEventListener('click', function () {
          searchInput.value = el.getAttribute('data-query');
          searchInput.form.submit();
        });
      });
      var clearBtn = suggestPanel.querySelector('.lyy-search-recent-clear');
      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          clearRecent();
          fetchSuggest(searchInput.value.trim());
        });
      }
    }

    function renderSuggest(products, queries, query) {
      var left = '<div class="lyy-search-pane-left">';
      left += '<div class="lyy-search-label">Suggestions</div>';

      if (queries && queries.length) {
        queries.forEach(function (q) {
          left += '<a class="custom-header__search-suggest-item lyy-search-query-item" href="/search?q=' + encodeURIComponent(q.text) + '">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9aa1ac" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.5" y2="16.5"/></svg>' +
            '<span style="flex:1">' + q.text + '</span></a>';
        });
      } else if (products.length) {
        products.forEach(function (product) {
          var image = product.featured_image && product.featured_image.url ? product.featured_image.url : '';
          var imageHtml = image ? '<img src="' + image + '" alt="" width="40" height="40" loading="lazy">' : '';
          left += '<a class="custom-header__search-suggest-item" href="' + product.url + '">' + imageHtml +
            '<span>' + product.title + '</span></a>';
        });
      } else {
        left += '<div class="custom-header__search-suggest-empty">No results for "' + query.replace(/"/g, '&quot;') + '"</div>';
      }

      left += renderRecentHTML() + '</div>';
      suggestPanel.innerHTML = left + renderTrendingHTML();
      suggestPanel.hidden = false;
      setOpen(true);
      bindPanelEvents();
    }

    function fetchSuggest(query) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product,query&resources[limit]=5&resources[options][unavailable_products]=last';
      fetch(url)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var resources = data.resources && data.resources.results ? data.resources.results : {};
          var products = resources.products || [];
          var queries = resources.queries || [];
          renderSuggest(products, queries, query);
        })
        .catch(hideSuggest);
    }

    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim();
      clearTimeout(suggestTimer);
      if (query.length < 2) {
        hideSuggest();
        return;
      }
      suggestTimer = setTimeout(function () { fetchSuggest(query); }, 250);
    });

    searchInput.addEventListener('focus', function () {
      var query = searchInput.value.trim();
      if (query.length >= 2) {
        fetchSuggest(query);
      } else if (trending.length || getRecent().length) {
        renderSuggest([], [], '');
        setOpen(true);
      }
    });

    if (searchInput.form) {
      searchInput.form.addEventListener('submit', function () {
        saveRecent(searchInput.value);
      });
    }

    if (backdrop) {
      backdrop.addEventListener('click', hideSuggest);
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.custom-header__search-wrap') && !event.target.closest('#lyy-search-backdrop')) {
        hideSuggest();
      }
    });

    searchInput.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') hideSuggest();
    });
  });
})();
